<template>
<!--  <div class="settings">-->
<!--    <div class="content">-->
<!--      <div class="wrapper">-->
<!--        <div class="main-wrap">-->

<!--          <div class="settings-header">-->
<!--            Chart of Accounts-->
<!--            <div class="settings-header__btn">-->
<!--              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>-->
<!--            </div>-->
<!--          </div>-->
          <div class="setting-component">
            <div class="setting-component__filter-block">
              <el-row :gutter="10">
                <el-col :span="3" :offset="0">
                  <el-input
                      style="width: 150px;"
                      v-model="filters.search"
                      :placeholder="$t('settings_searchAccounts')"
                      prefix-icon="el-icon-search"/>
                </el-col>
                <el-col :span="21" :offset="0">
                  <el-row :gutter="10">
                    <el-col :span="11" :offset="0" style="height: 42px; display: flex; align-items: center;">
                      <div style="margin-right: 20px;">
                        {{$t('settings_show')}}:
                      </div>
                      <el-checkbox
                          class="show-active-accounts-checkbox"
                          name="type"
                          style="margin-right: 30px;"
                          @change="toggleShowActiveAccountsOnly"
                          v-model="filters.activeAccountsOnly">
                        Inactive Accounts
                      </el-checkbox>
                      <el-checkbox-group
                          class="checkboxes"
                          v-model="filters.entityTypes">
                        <el-checkbox
                            v-for="checkbox in typesList"
                            :key="checkbox.id"
                            :label="checkbox.id"
                            @change="selectTypes(filters.entityTypes)"
                        >
                          {{checkbox.name}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-col>
                    <el-col :span="10" :offset="0" style="height: 42px; display: flex; align-items: center;">
                      <div style="margin-right: 20px;">
                        {{$t('settings_columns')}}:
                      </div>
                      <el-checkbox-group
                          class="checkboxes"
                          v-model="filters.shownColumns">
                        <el-checkbox
                            v-for="checkbox in showColumnsList"
                            :key="checkbox.id"
                            :label="checkbox.id"
                            @change="toggleColumns(filters.shownColumns)"
                        >
                          {{checkbox.name}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-col>
                    <el-col :span="3" :offset="0" style="height: 42px; display: flex; justify-content: flex-end; align-items: center; text-align: right;">
                      <!--                      <el-button type="success" size="mini" @click="openATDashboard">aT Dashboard</el-button>-->
                      <el-button type="primary" size="mini" @click="openGL">GENERAL LEDGER</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

            </div>

            <!-- Title, btn -->
            <!--            <div class="title">-->
            <!--              <div class="title__btn">-->
            <!--                <el-button type="primary" size="mini" @click="openGL">GENERAL LEDGER</el-button>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="grid-wrapper" style="width: 100%; height: calc(100vh - 260px); margin-top: 20px;">
              <ag-grid-vue
                  style="width: 100%; height: 100%;"
                  class="ag-theme-balham"
                  id="myGrid"
                  :floatingFilter="true"
                  :suppressMultiSort="false"
                  :suppressHorizontalScroll="true"
                  :gridOptions="gridOptions"
                  :getContextMenuItems="getContextMenuItems"
                  :defaultColDef="defaultColDef"
                  :rowData="rowData"
                  :icons="icons"
                  :treeData="true"
                  :animateRows="true"
                  :modules="modules"
                  :getDataPath="getDataPath"
                  :getRowNodeId="getRowNodeId"
                  :getRowHeight="getRowHeight"
                  :autoGroupColumnDef="autoGroupColumnDef"
                  :columnDefs="columnDefs"
                  :groupDefaultExpanded="groupDefaultExpanded"
                  @grid-ready="onGridReady"
                  :context="context"
                  :rowSelection="rowSelection"
                  @selection-changed="onSelectionChanged"
                  @rowClicked="onRowClicked"
                  :rowClassRules="rowClassRules"
              />
            </div>
            <c-o-a-add-group-modal
                ref="coaAddGroupModal"
                :cashFlowList="clashflowArr"
                @loadList="loadListAfterCreate"/>
            <c-o-a-add-class-modal
                ref="coaAddClassModal"
                @loadList="loadListAfterCreate"/>
            <c-o-a-add-account-modal
                :rowData="rowData"
                :currencyList="currencyList"
                :accounts="taxAccounts"
                :cashFlowList="clashflowArr"
                ref="coaAddAccountModal"
                :accounts-names-list="accountsNamesList"
                @loadList="loadListAfterCreate"/>
            <c-o-a-add-sub-account-modal
                :currencyList="currencyList"
                :rowData="rowData"
                :accounts="taxAccounts"
                :cashFlowList="clashflowArr"
                ref="coaAddSubAccountModal"
                :accounts-names-list="accountsNamesList"
                @loadList="loadListAfterCreate"/>
            <generall-ledger-detailed-modal
                :currencyList="currencyList"
                ref="generallLedgerDetailedModal"
                @loadList="loadList"/>
            <assign-tax-account-modal
                ref="assignTaxAccountModal"
                :accounts="taxAccounts"
                @loadList="loadListAfterCreate"/>
            <c-o-a-add-sub-tax-account-modal3
                :currencyList="currencyList"
                ref="coaAddSubTaxAccountModal"
                :rowData="rowData"
                :accounts="taxAccounts"
                :cashFlowList="clashflowArr"
                :accounts-names-list="accountsNamesList"
                @loadList="loadListAfterCreate"/>
          </div>
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import axios from "axios";
import ActionCellRenderer from "@/components/settings/settingsGlAccounts2/actionCellRenderer.vue";
import AccountTypeCellRenderer from "@/components/settings/settingsGlAccounts2/accountTypeCellRenderer.vue";
import COAAddGroupModal from "@/components/settings/settingsGlAccounts2/COAAddGroupModal";
import COAAddClassModal from "@/components/settings/settingsGlAccounts2/COAAddClassModal";
import COAAddAccountModal from "@/components/settings/settingsGlAccounts2/COAAddAccountModal";
import COAAddSubAccountModal from "@/components/settings/settingsGlAccounts2/COAAddSubAccountModal";
import GenerallLedgerDetailedModal from "@/components/settings/settingsGlAccounts2/GenerallLedgerDetailedModal";
import AssignTaxAccountModal from "@/components/settings/settingsGlAccounts2/assignTaxAccountModal";
import { AllModules } from "@ag-grid-enterprise/all-modules";
import COAAddSubTaxAccountModal3 from "../../../components/settings/settingsGlAccounts2/COAAddSubTaxAccountModal3";

export default {
  name: "ChartOfAccounts",
  props: {
    state: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    taxAccounts() {
      return this.rowData.filter(val => val.entityType === 'account' && val.taxId)
    },
    accountsNamesList() {
      return this.rowData.filter(val => val.entityType === 'account').map(bal => ({name: bal.name}))
    }
  },
  data() {
    return {
      filters: {
        search: '',
        activeAccountsOnly: false,
        show: [],
        openingBalances: [],
        entityTypes: [],
        shownColumns: ['codeTax', 'report', 'currencycode', 'clashflowObj.name']
      },
      whatToShowList: [
        { id: 1, name: this.$i18n.t('settings_businessCenters') },
        { id: 2, name: this.$i18n.t('settings_businessUnits') },
        { id: 3, name: this.$i18n.t('settings_warehouses') },
        { id: 4, name: this.$i18n.t('settings_engagements') },
        { id: 5, name: this.$i18n.t('settings_projects') },
        { id: 6, name: this.$i18n.t('settings_employee') }
      ],
      openingBalancesList: [
        { id: 1, name: this.$i18n.t('settings_locked')},
        { id: 2, name: this.$i18n.t('settings_hide')},
        { id: 3, name: this.$i18n.t('settings_class')},
        { id: 4, name: this.$i18n.t('settings_group')},
        { id: 5, name: this.$i18n.t('settings_account')},
        { id: 6, name: this.$i18n.t('settings_subAccounts')}
      ],
      typesList: [
        { id: 'type', name: this.$i18n.t('settings_Type')},
        { id: 'class', name: this.$i18n.t('settings_class')},
        { id: 'group', name: this.$i18n.t('settings_group')},
        { id: 'account', name: this.$i18n.t('settings_account')}
      ],
      showColumnsList: [
        { id: 'codeTax', name: this.$i18n.t('settings_accountThink_GLAccounts_tax') },
        { id: 'report', name: this.$i18n.t('settings_accountThink_GLAccounts_report') },
        { id: 'currencycode', name: this.$i18n.t('settings_accountThink_GLAccounts_currency') },
        { id: 'clashflowObj.name', name: 'Cashflow' },
      ],
      rowData: [],
      // grid settings
      gridOptions: null,
      getDataPath: null,
      getRowNodeId: null,
      getRowHeight: null,
      autoGroupColumnDef: null,
      columnDefs: null,
      gridColumnApi: null,
      domLayout: 'autoHeight',
      gridApi: null,
      defaultColDef: null,
      groupDefaultExpanded: -1,
      context: null,
      rowSelection: "multiple",
      currencyList: [],
      modules: AllModules,
      clashflowArr: [],
      rowClassRules: null,
      icons: {
        groupExpanded:
            '<img src="https://www.ag-grid.com/example-assets/group/contract.png" style="height: 12px; width: 12px;padding-right: 2px"/>',
        groupContracted:
            '<img src="https://www.ag-grid.com/example-assets/group/expand.png" style="height: 12px; width: 12px;padding-right: 2px"/>',
      },
      disabledAccountsTypeId: [8,11,12,13]
    }
  },
  components: {
    COAAddSubTaxAccountModal3,
    AssignTaxAccountModal,
    GenerallLedgerDetailedModal,
    COAAddSubAccountModal,
    COAAddAccountModal,
    COAAddClassModal,
    COAAddGroupModal,
    AgGridVue,
    actionCellRenderer: ActionCellRenderer,
    accountTypeCellRenderer: AccountTypeCellRenderer
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      isRowSelectable: function(rowNode) {
        return !(rowNode.data.entityType === 'account' && !rowNode.data.active)
      },
    }
    this.getDataPath = data => {
      return data.filePath
    }
    this.getRowNodeId = data => {
      return data.id;
    }
    this.getRowHeight = params => {
      return 40;
    }
    this.autoGroupColumnDef = {
      headerName: this.$i18n.t('settings_accountThink_GLAccounts_accountsList'),
      field: 'name',
      suppressMenu: true,
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: function(params) {
          return `<span class="account-list-text grid-text">${params.node.data.name} </span>`
        }
      },
      cellClass: 'account-list',
      cellStyle: { 'border-right-color': '#e2e2e2', 'padding-left': '10px', 'align-items': 'center', 'display': 'flex' }
    }
    this.columnDefs = [
      {
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_dbCode'),
        field: "code",
        suppressMenu: true,
        width: 60,
        headerClass: 'db-code-header',
        cellClass: 'db-code',
        cellStyle: function(params) {
          return {'align-items': 'center; display: flex; padding-left: 10px; border-right-color: #e2e2e2;'}
        }
      },
      {
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_accNo'),
        field: "number",
        cellClass: 'acc-no',
        suppressMenu: true,
        width: 70,
        headerClass: 'acc-no-header center-header',
        cellStyle: { 'border-right-color': '#e2e2e2', 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: '',
        field: "indelible",
        cellClass: 'indelible',
        suppressMenu: true,
        width: 30,
        cellRenderer: function(params) {
          return `<span class="account-list-text grid-text">${params.node.data.indelible ? '<i class="fas fa-lock t-lock"></i>' : ''} </span>`
        },
        headerClass: 'indelible-header center-header',
        cellStyle: { 'border-right-color': '#e2e2e2', 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_setAs'),
        field: "DRCRCode",
        suppressMenu: true,
        headerClass: 'set-as-header center-header',
        width: 60,
        cellClass: 'set-as-cell',
        cellRenderer: function(params) {
          return `<div class="grid-text set-as-text">
                    <span class="dr-text">
                      ${params.node.data.DRCRCode === 'DR' ? 'DR' : ''}
                    </span>
                    <span class="cr-text">
                      ${params.node.data.DRCRCode === 'CR' ? 'CR' : ''}
                    </span>
                  </div>`
        },
        cellStyle: { 'border-right-color': '#e2e2e2', 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_tax'),
        headerClass: 'tax-header center-header',
        field: "codeTax",
        suppressMenu: true,
        width:80,
        cellStyle: { 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: 'Account Type',
        headerClass: 'tax-header center-header',
        field: "accountTypeName",
        cellRendererFramework: "accountTypeCellRenderer",
        suppressMenu: true,
        width:50,
        cellStyle: { 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_report'),
        field: "report",
        headerClass: 'report-header center-header',
        suppressMenu: true,
        width:75,
        cellStyle: { 'border-right-color': '#e2e2e2', 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_currency'),
        field: "currencycode",
        headerClass: 'currency-header center-header',
        suppressMenu: true,
        width:50,
        cellStyle: { 'border-right-color': '#e2e2e2', 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: 'Cashflow',
        field: "clashflowObj.name",
        width:70,
        headerClass: 'type-header center-header',
        suppressMenu: true,
        cellRenderer: function(params) {
          return `<span class="grid-text type-text">${params.node.data.clashflowObj ? params.node.data.clashflowObj.name : ''}</span>`
        },
        cellStyle: { 'border-right-color': '#e2e2e2', 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      },
      {
        headerName: this.$i18n.t('settings_accountThink_GLAccounts_action'),
        width: 70,
        field: "action",
        headerClass: 'action-header center-header',
        suppressMenu: true,
        cellRendererFramework: "actionCellRenderer",
        cellStyle: { 'align-items': 'center', 'display': 'flex', 'justify-content': 'center' }
      }
    ]
    this.defaultColDef = {
      editable: (node) => {
        if (this.state === 'view') return false
        if(node.colDef.cellClass === 'acc-no') {
          return true
        }
        if(node.colDef.cellClass === 'account-list') {
          return true
        }
      },
      onCellValueChanged : (node) => {
        if (!node.newValue) {
          console.log('node', node)
          // node.api.setFocusedCell(node.node.rowIndex, node.colDef, false)
          // node.api.startEditingCell({
          //   rowIndex: node.node.rowIndex,
          //   colKey: node.colDef,
          //   charPress: node.oldValue
          // });
          return
        }
        alert('hello')
      }
    }
    this.rowSelection = "multiple";
    this.context = { componentParent: this }
    this.rowClassRules = {
      'no-access-row': "(!data.active && data.entityType === 'account')",
    };
    if (this.state === 'view') {
      this.columnDefs.pop()
    }
  },
  mounted() {
    this.loadList()
    this.loadCompanyInfo()
    this.gridColumnApi = this.gridOptions.columnApi
    this.gridColumnApi.moveColumn("code", 0)
    this.gridColumnApi.moveColumn("number", 1)
    this.gridColumnApi.moveColumn("indelible", 2)
    this.gridApi = this.gridOptions.api
    this.gridApi.sizeColumnsToFit()
  },
  methods: {
    openATDashboard() {
      this.$router.push(`/account-think?companyId=${this.$route.query.companyId}`)
    },
    openGL() {
      this.$router.push(`/general-ledger?companyId=${this.$route.query.companyId}`)
    },
    onGridReady(params) {
      params.api.sizeColumnsToFit()
    },
    loadList() {
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios
            .get(`/api/v1/accountTree/get?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('response', response.data.tree)
              this.rowData = this.filterRowData(response.data.tree)
              this.clashflowArr = response.data.clashflowArr
              this.gridApi.sizeColumnsToFit()
              loader.hide()
              resolve(response.data.tree)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        this.gridApi.sizeColumnsToFit()
      })
    },
    filterRowData(rowData) {
      if (!this.filters.activeAccountsOnly) {
        return rowData.filter((item) => {
          return !(item.entityType === 'account' && !item.active)

        })
      } else {
        return rowData
      }
    },
    async loadListAfterCreate({ entityType, id }) {
      try {
        console.log('entityType, id', entityType, id)
        await this.loadList()
        await this.selectCreatedTask(entityType, id)
      } catch (err) {
        console.log(err)
      }
    },
    selectCreatedTask(entityType, id) {
      return new Promise ((resolve, reject) => {
        this.gridApi.forEachNode((node, index) => {
          // CHECK IF USER HAVE ACCESS TO TE ROW
          if (node.data.entityType === entityType && node.data.id === id) {
            // MOVE TASK TO MIDDLE CENTER
            this.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
            node.setSelected(true);
            resolve(node)
          }
        })
      })
    },
    loadCompanyInfo() {
      let loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
      axios
          .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=create`)
          .then(response => {
            this.currencyList = response.data.currencyList
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    async toggleShowActiveAccountsOnly(val) {
      try {
        await this.loadList()
      } catch (err) {
        console.log(err)
      }
    },
    getContextMenuItems(params) {
      if (this.state === 'view') return []
      const data = params.node.data
      const contextMenuItemList = []
      switch (data.entityType) {
          // case 'type':
          //   contextMenuItemList.push(
          //       {
          //         name: this.$i18n.t('general_grid_contextMenu_addClass'),
          //         disabled: false,
          //         action: () => {
          //           this.$refs.coaAddClassModal.openModal('create', params)
          //         },
          //         icon: '<i class="el-icon-plus"></i>',
          //       }
          //   )
          // break
        case 'class':
          contextMenuItemList.push(
              // {
              //   name: this.$i18n.t('general_grid_contextMenu_addClass'),
              //   disabled: false,
              //   action: () => {
              //     this.$refs.coaAddClassModal.openModal('create', params)
              //   },
              //   icon: '<i class="el-icon-plus"></i>',
              // },
              {
                name: this.$i18n.t('general_grid_contextMenu_editClass'),
                disabled: false,
                action: () => {
                  this.$refs.coaAddClassModal.openModalEdit('update', params)
                },
                icon: '<i class="el-icon-edit"></i>',
              },
              {
                name: this.$i18n.t('general_grid_contextMenu_addGroup'),
                disabled: false,
                action: () => {
                  this.$refs.coaAddGroupModal.openModal('create', params)
                },
                icon: '<i class="el-icon-plus"></i>',
              }
          )
          break
        case 'group':
          contextMenuItemList.push(
              {
                name: this.$i18n.t('general_grid_contextMenu_addGroup'),
                disabled: false,
                action: () => {
                  this.$refs.coaAddGroupModal.openModal('create', params)
                },
                icon: '<i class="el-icon-plus"></i>',
              },
              {
                name: this.$i18n.t('general_grid_contextMenu_editGroup'),
                disabled: false,
                action: () => {
                  this.$refs.coaAddGroupModal.openModalEdit('update', params)
                },
                icon: '<i class="el-icon-edit"></i>',
              },
              {
                name: this.$i18n.t('general_grid_contextMenu_addAccount'),
                disabled: false,
                action: () => {
                  this.$refs.coaAddAccountModal.openModal('create', params)
                },
                icon: '<i class="el-icon-plus"></i>'
              }
          )
          break
        case 'account':
          if (data.active) {
            contextMenuItemList.push(
                // {
                //   name: this.$i18n.t('general_grid_contextMenu_addAccount'),
                //   disabled: false,
                //   action: () => {
                //     this.$refs.coaAddAccountModal.openModal('create', params)
                //   },
                //   icon: '<i class="el-icon-plus"></i>',
                // },
                {
                  name: this.$i18n.t('general_grid_contextMenu_editAccount'),
                  disabled: false,
                  action: () => {
                    data.taxId ? this.$refs.coaAddSubTaxAccountModal.openModalEdit('update', params) : this.$refs.coaAddAccountModal.openModalEdit('update', params)
                  },
                  icon: '<i class="el-icon-edit"></i>',
                },
                {
                  name: this.$i18n.t('general_grid_contextMenu_addSubAccount'),
                  disabled: false,
                  action: () => {
                    // this.disabledAccountsTypeId.some(val => val === data.accountTypeId) ? this.$refs.coaAddSubTaxAccountModal.openModal('create', params) : this.$refs.coaAddSubAccountModal.openModal('create', params)
                    data.taxId ? this.$refs.coaAddSubTaxAccountModal.openModal('create', params) : this.$refs.coaAddSubAccountModal.openModal('create', params)
                  },
                  icon: '<i class="el-icon-plus"></i>',
                }
            )
          }
          break
        case 'folder':
          contextMenuItemList.push(
              {
                name: this.$i18n.t('general_grid_contextMenu_addAccount'),
                disabled: false,
                action: () => {
                  this.$refs.coaAddAccountModal.openModal('create', params)
                },
                icon: '<i class="el-icon-plus"></i>',
              }
          )
          break
      }
      return contextMenuItemList
    },
    methodFromActionCell(action, params) {
      switch (action) {
        case 'delete':
          return this.deleteNode(params.node.data)
        case 'add':
          // if (params.node.data.entityType === 'type') return this.$refs.coaAddClassModal.openModal('create', params)
          if (params.node.data.entityType === 'class') return this.$refs.coaAddGroupModal.openModal('create', params)
          if (params.node.data.entityType === 'group') return this.$refs.coaAddAccountModal.openModal('create', params)
          if (params.node.data.entityType === 'account') return this.$refs.coaAddSubAccountModal.openModal('create', params)
          if (params.node.data.entityType === 'sub-account') return this.$refs.coaAddSubAccountModal.openModal('create', params)
          break;
        case 'update':
          if (params.node.data.entityType === 'class') return this.$refs.coaAddClassModal.openModalEdit('update', params)
          if (params.node.data.entityType === 'group') return this.$refs.coaAddGroupModal.openModalEdit('update', params)
          if (params.node.data.entityType === 'account' && params.node.data.taxId) return this.$refs.coaAddSubTaxAccountModal.openModalEdit('update', params)
          if (params.node.data.entityType === 'account') return this.$refs.coaAddAccountModal.openModalEdit('update', params)
          if (params.node.data.entityType === 'sub-account') return this.$refs.coaAddSubAccountModal.openModalEdit('update', params)
          break;
        // case 'create-tax-account':
        //   this.$refs.coaAddSubTaxAccountModal.openModal('create', params)
        //   break;
        // case 'assign-tax':
        //   this.$refs.assignTaxAccountModal.openModal(params)
        //   break;
        case 'updateActiveAccount':
          this.updateActiveAccount(params)
          break;
      }
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    updateActiveAccount(params) {
      const payload = {
        active: !params.node.data.active
      }
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/account/updateActive?accountId=${params.node.data.id}`, payload)
          .then(response => {
            this.loadListAfterCreate({ entityType: 'account', id: params.node.data.id })
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    openGenerallLedgerDetailedModal(params) {
      console.log('params111', params)
      this.$refs.generallLedgerDetailedModal.openModal(params)
    },
    deleteNode(data) {
      let url = null
      switch (data.entityType) {
        case 'class':
          url = `/api/v1/accountClass/delete?classId=${data.id}`
          break;
        case 'group':
          url = `/api/v1/accountGroup/delete?groupId=${data.id}`
          break;
        case 'account':
        case 'sub-account':
          url = `/api/v1/account/delete?companyId=${this.$route.query.companyId}&accountId=${data.id}`
      }
      console.log('data name', data.name)
      this.$confirm(this.$t('settings_accountThink_deleteName', { name: data.name }), this.$t('general_warning'), {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(url)
            .then(response => {
              this.notification(this.$t('general_success'), this.$t('notification_nodeRemoved', { name: data.name }), "success")
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      })
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    selectTypes(filters) {
      this.gridApi.forEachNode((node) => {
        node.setSelected(filters.some(bal => {
          if (bal === 'account' && node.data.entityType === 'folder') {
            return true
          }
          return bal === node.data.entityType
        }))
      })
      if (!filters.length) {
        this.gridApi.deselectAll()
      }
    },
    toggleColumns(columns) {
      console.log('columns', columns)
      const shownColumns = ['code', 'number', 'DRCRCode', 'action']
      const showColumns = shownColumns.concat(columns)
      const allColumns = this.gridColumnApi.getAllColumns().map(val => val.colId)
      const hideColumns = allColumns.filter(x => !showColumns.includes(x));
      this.gridColumnApi.setColumnsVisible(hideColumns, false);
      this.gridColumnApi.setColumnsVisible(showColumns, true);
      this.gridApi.sizeColumnsToFit()
    },
    onSelectionChanged(api) {
      console.log(api)
    },
    onRowClicked(api) {
      this.filters.entityTypes = []
    }
  },
  watch: {
    'filters.search': function (val) {
      this.gridApi.setQuickFilter(val)
    }
  }
}

const rounded = (number) => {
  return +number.toFixed(2);
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

.title {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  margin-bottom: 10px;
  &__btn {
    position: absolute;
    top: 0;
    right: 0;
  }
}
.setting-component {
  &__filter-block {
    // display: flex;
    // justify-content: space-between;
    // margin-bottom: 20px;
    .search-accounts {
      display: flex;
      flex-direction: column;
      width: 100%;
      .el-autocomplete {
        width :100%;
      }
      .show-active-accounts-checkbox {
        margin-top: 20px;
      }
    }
    .what-to-show {
      display: flex;
      align-items: center;
      //justify-content: center;
      &__content {
        display: flex;
        align-items: center;
        .show-title {
          margin-right: 20px;
        }
      }
      .enter-opening-balance__content {
        display: flex;
        //flex-direction: column;
        align-items: center;
        //justify-content: center;
        margin-top:20px;
        .opening-balance-title {
          margin-right:20px;
        }
      }
    }
  }
  #myGrid {
    border: 1px solid #e2e2e2;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    //margin-bottom: 50px;
    /deep/ .ag-root-wrapper {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    /deep/.center-header {
      .ag-header-cell-label {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    /deep/.set-as-cell {
      span {
        width: 100%;
        .set-as-text {
          width:100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .dr-text {
            padding: 0 6px;
            //border-right: 1px solid black;
            box-sizing: border-box;
            min-width: 50%;
            display: flex;
            justify-content: center;
          }
          .cr-text {
            //border-left: 1px solid black;
            box-sizing: border-box;
            min-width: 50%;
            padding: 0 6px;
            display: flex;
            justify-content: center;
            color: red;
          }
        }
      }
    }
    /deep/.action-wrapper {
      display: flex;
      .btn {
        background-color: #ecf5ff;
        border-color: #d9ecff;
        display: inline-block;
        height: 32px;
        padding: 0 10px;
        line-height: 30px;
        font-size: 12px;
        color: #409EFF;
        border-width: 1px;
        border-style: solid;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        white-space: nowrap;
        cursor: pointer;
        &.add-btn {
          margin-right: 10px;
        }
        &.edit-btn {
          margin-right: 10px;
        }
      }
    }
  }
}
/deep/.ag-theme-balham .ag-cell.ag-cell-inline-editing{
  height:100%;
  .ag-input-text-wrapper{
    height:100%;
  }
}
/deep/.no-access-row{
  background-color: #efa8b2 !important;
}
/deep/.t-lock {
  margin-right: 10px;
  font-size: 10px;
  color: #7d8791;
}
</style>
